import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../utils/api';

const MisTarjetas = () => {
    const [tarjetas, setTarjetas] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        api.get('/perfil/mis-tarjetas')
            .then(({ data }) => setTarjetas(data))
            .catch(() => {})
            .finally(() => setLoading(false));
    }, []);

    const estadoBadge = (estado) => {
        const map = {
            activa:      { label: 'Activa',       cls: 'bg-green-100 text-green-700' },
            sin_activar: { label: 'Sin activar',  cls: 'bg-yellow-100 text-yellow-700' },
            bloqueada:   { label: 'Bloqueada',    cls: 'bg-red-100 text-red-700' },
        };
        const e = map[estado] || { label: estado, cls: 'bg-gray-100 text-gray-600' };
        return <span className={`px-2 py-0.5 rounded-full text-xs font-medium ${e.cls}`}>{e.label}</span>;
    };

    if (loading) {
        return (
            <div className="flex items-center justify-center h-64">
                <div className="text-gray-400 text-sm">Cargando tarjetas...</div>
            </div>
        );
    }

    if (tarjetas.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-64 gap-3">
                <div className="text-5xl">💳</div>
                <p className="text-gray-500 text-sm">No tienes tarjetas asignadas aún.</p>
            </div>
        );
    }

    return (
        <div>
            <div className="mb-6">
                <h1 className="text-2xl font-bold text-gray-800">Mis Tarjetas NFC</h1>
                <p className="text-gray-500 text-sm mt-1">Selecciona una tarjeta para editar tu perfil digital.</p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {tarjetas.map(tarjeta => (
                    <div
                        key={tarjeta.uuid}
                        onClick={() => navigate(`/mis-tarjetas/${tarjeta.uuid}`)}
                        className="bg-white rounded-2xl shadow-sm border border-gray-100 p-5 cursor-pointer hover:shadow-md hover:border-blue-200 transition-all group"
                    >
                        <div className="flex items-center gap-4">
                            <div className="w-16 h-16 rounded-full overflow-hidden bg-gray-100 flex-shrink-0">
                                {tarjeta.foto_url ? (
                                    <img
                                        src={tarjeta.foto_url}
                                        alt="Foto"
                                        className="w-full h-full object-cover"
                                    />
                                ) : (
                                    <div className="w-full h-full flex items-center justify-center text-2xl text-gray-300">
                                        👤
                                    </div>
                                )}
                            </div>
                            <div className="flex-1 min-w-0">
                                <p className="font-semibold text-gray-800 truncate">
                                    {tarjeta.nombre || tarjeta.cargo ? (
                                        `${tarjeta.nombre} ${tarjeta.apellido}`.trim() || 'Sin nombre'
                                    ) : 'Perfil sin configurar'}
                                </p>
                                <p className="text-sm text-gray-500 truncate">{tarjeta.cargo || '—'}</p>
                                <div className="mt-1.5 flex items-center gap-2">
                                    {estadoBadge(tarjeta.estado)}
                                    <span className="text-xs text-gray-400 font-mono">{tarjeta.codigo}</span>
                                </div>
                            </div>
                        </div>
                        <div className="mt-4 pt-4 border-t border-gray-50 flex items-center justify-between">
                            <span className="text-xs text-gray-400">
                                {tarjeta.fecha_activacion
                                    ? `Activada ${new Date(tarjeta.fecha_activacion).toLocaleDateString('es-CO')}`
                                    : 'No activada'}
                            </span>
                            <span className="text-blue-500 text-sm font-medium group-hover:underline">Editar →</span>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MisTarjetas;
